(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arw-home-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arw-home-carousel')){
  customElements.define('arw-home-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.track=this.querySelector('.arw-home-carousel__slides');
      this.slides=Array.from(this.querySelectorAll('[data-slide]'));
      this.controls=this.querySelector('[data-controls]');
      this.index=0;
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true';
      this.hovered=false;
      this.keyboardFocus=false;
      this.onScreen=true;
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.manualStep(-1),options);
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.manualStep(1),options);
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.sync();}},options);
      this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){this.hovered=false;this.sync();}},options);
      this.addEventListener('focusin',()=>{this.keyboardFocus=true;this.sync();},options);
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.keyboardFocus=false;this.sync();}},options);
      this.addEventListener('keydown',e=>{
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
          e.preventDefault();this.manualStep(e.key==='ArrowRight'?1:-1);
        }
      },options);
      this.track.addEventListener('scroll',()=>{
        if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.readPosition();});
        clearTimeout(this.settleTimer);
        this.settleTimer=setTimeout(()=>{this.navigationTarget=null;this.readPosition();this.sync();},160);
      },{passive:true,signal:this.abort.signal});
      this.track.addEventListener('pointerdown',e=>{
        if(!e.isPrimary||e.button!==0||e.target.closest('button'))return;
        this.paused=true;this.sync();
        if(e.pointerType==='touch')return;
        this.drag={id:e.pointerId,x:e.clientX,y:e.clientY,left:this.track.scrollLeft,start:this.index,moved:false};
      },options);
      this.track.addEventListener('pointermove',e=>{
        const d=this.drag;
        if(!d||e.pointerId!==d.id)return;
        const dx=e.clientX-d.x,dy=e.clientY-d.y;
        if(!d.moved&&Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){
          d.moved=true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(e.pointerId);
        }
        if(d.moved){
          if(e.cancelable)e.preventDefault();
          this.track.scrollLeft=d.left-dx;
        }
      },options);
      this.track.addEventListener('pointerup',e=>this.finishDrag(e),options);
      this.track.addEventListener('pointercancel',e=>this.finishDrag(e,true),options);
      this.track.addEventListener('lostpointercapture',e=>{if(this.drag?.id===e.pointerId)this.finishDrag(e,true);},options);
      this.track.addEventListener('dragstart',e=>e.preventDefault(),options);
      this.addEventListener('click',e=>{
        if(Date.now()<(this.suppressClickUntil||0)){e.preventDefault();e.stopImmediatePropagation();}
      },{capture:true,signal:this.abort.signal});
      document.addEventListener('visibilitychange',()=>this.refresh(),options);
      this.reduced.addEventListener('change',()=>this.sync(),options);
      this.observer=new IntersectionObserver(entries=>{this.onScreen=entries[0].isIntersecting;this.sync();});
      this.observer.observe(this);
      this.resizeObserver=new ResizeObserver(()=>this.show(this.index,false));
      this.resizeObserver.observe(this.track);
      this.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('[data-slide]');
        if(slide){this.paused=true;this.show(this.slides.indexOf(slide),false);}
      },options);
      this.refresh();
    }
    valid(){
      return this.slides.map((s,i)=>({s,i})).filter(({s})=>!s.dataset.end||Date.now()<Date.parse(s.dataset.end)).map(x=>x.i);
    }
    refresh(){
      const valid=this.valid();
      this.slides.forEach((s,i)=>{s.hidden=!valid.includes(i);});
      if(this.controls)this.controls.hidden=valid.length<2;
      this.show(valid.includes(this.index)?this.index:valid[0],false);
      clearTimeout(this.expiryTimer);
      const deadlines=this.slides.map(s=>Date.parse(s.dataset.end)).filter(n=>Number.isFinite(n)&&n>Date.now());
      if(deadlines.length)this.expiryTimer=setTimeout(()=>this.refresh(),Math.min(Math.min(...deadlines)-Date.now()+100,2147483647));
    }
    offset(slide){
      return slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft;
    }
    readPosition(){
      const valid=this.valid();
      if(!valid.length)return;
      this.index=valid.reduce((best,i)=>Math.abs(this.offset(this.slides[i])-this.track.scrollLeft)<Math.abs(this.offset(this.slides[best])-this.track.scrollLeft)?i:best,valid[0]);
      this.slides.forEach((slide,i)=>{
        const active=i===this.index&&!slide.hidden;
        slide.inert=!active;
        slide.setAttribute('aria-hidden',String(!active));
      });
    }
    show(index,animate=true){
      if(index===undefined||!this.slides[index]||this.slides[index].hidden)return;
      this.navigationTarget=index;
      this.track.scrollTo({left:this.offset(this.slides[index]),behavior:animate&&!this.reduced.matches?'smooth':'instant'});
      this.index=index;
      this.readPosition();
      this.sync();
    }
    finishDrag(e,cancelled=false){
      const d=this.drag;
      if(!d||e.pointerId!==d.id)return;
      this.drag=null;
      this.track.classList.remove('is-dragging');
      if(this.track.hasPointerCapture(e.pointerId))this.track.releasePointerCapture(e.pointerId);
      if(d.moved){
        this.suppressClickUntil=Date.now()+700;
        const valid=this.valid(),pos=valid.indexOf(d.start),dx=e.clientX-d.x;
        const threshold=Math.min(100,this.track.clientWidth*.18);
        const shift=!cancelled&&Math.abs(dx)>=threshold?(dx<0?1:-1):0;
        this.show(valid[Math.max(0,Math.min(valid.length-1,pos+shift))]);
      }
      this.sync();
    }
    manualStep(direction){this.paused=true;this.step(direction);}
    step(direction){
      const valid=this.valid();
      if(!valid.length)return;
      const position=valid.indexOf(this.navigationTarget??this.index);
      this.show(valid[(position+direction+valid.length)%valid.length]);
    }
    sync(){
      clearTimeout(this.timer);
      const stopped=this.paused||this.reduced.matches||this.hovered||this.keyboardFocus||this.drag||document.hidden||!this.onScreen;
      if(!stopped&&this.valid().length>1)this.timer=setTimeout(()=>this.step(1),Number(this.dataset.interval)||7000);
    }
    disconnectedCallback(){
      clearTimeout(this.timer);clearTimeout(this.expiryTimer);clearTimeout(this.settleTimer);
      if(this.frame)cancelAnimationFrame(this.frame);
      this.observer?.disconnect();this.resizeObserver?.disconnect();this.abort?.abort();
      this.initialized=false;this.drag=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arw-women-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-women-catalog]').forEach((catalog) => {
      if (catalog.dataset.initialized) return;
      catalog.dataset.initialized = 'true';
      const cards = Array.from(catalog.querySelectorAll('[data-women-kind]'));
      const filters = Array.from(catalog.querySelectorAll('[data-women-filter]'));
      const count = catalog.querySelector('[data-women-count]');
      const more = catalog.querySelector('[data-women-more]');
      const empty = catalog.querySelector('[data-women-empty]');
      const favorites = catalog.querySelector('[data-women-favorites]');
      const allHeading = catalog.querySelector('[data-women-all-heading]');
      const localFilters = catalog.querySelector('[data-local-filters]').dataset.localFilters === 'true';
      let selected = 'all';
      let visibleLimit = 24;
      const update = (focusNew = false) => {
        const previouslyVisible = new Set(cards.filter(card => !card.hidden));
        const matching = cards.filter(card => selected === 'all' || card.dataset.womenKind === selected);
        const visible = matching.slice(0, visibleLimit);
        const visibleSet = new Set(visible);
        cards.forEach(card => { card.hidden = !visibleSet.has(card); });
        filters.forEach(filter => {
          if (filter.dataset.womenFilter === selected) filter.setAttribute('aria-current', 'page');
          else filter.removeAttribute('aria-current');
        });
        count.textContent = count.dataset.countTemplate.replace('__SHOWN__', visible.length).replace('__TOTAL__', matching.length);
        more.hidden = matching.length <= visibleLimit;
        empty.hidden = matching.length > 0;
        if (favorites) favorites.hidden = selected !== 'all';
        if (allHeading) allHeading.hidden = selected !== 'all';
        if (focusNew) {
          const firstNew = visible.find(card => !previouslyVisible.has(card));
          firstNew?.querySelector('h3 a, a')?.focus({preventScroll:true});
        }
      };
      filters.forEach(filter => filter.addEventListener('click', event => {
        if (!localFilters || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        selected = filter.dataset.womenFilter;
        visibleLimit = 24;
        const url = new URL(window.location.href);
        url.hash = selected === 'all' ? '' : selected === 'jackets' ? 'jakker' : 'sko';
        history.pushState(null, '', url);
        update();
      }));
      more.addEventListener('click', () => { visibleLimit += 24; update(true); });
      const restore = () => {
        if (localFilters) selected = location.hash === '#jakker' ? 'jackets' : location.hash === '#sko' ? 'shoes' : 'all';
        visibleLimit = 24;
        update();
      };
      window.addEventListener('popstate', restore);
      restore();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function setupArwHoverMenus(root = document) {
    const hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    root.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
      if (menu.dataset.arwHoverReady) return;
      menu.dataset.arwHoverReady = 'true';
      menu.classList.add('arw-hover-menu');
      const details = menu.querySelector('details');
      const summary = details.querySelector('summary');
      let openedByPointer = false;
      let openTimer;
      let closeTimer;
      const cancelTimers = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      };
      const close = () => {
        cancelTimers();
        openedByPointer = false;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        cancelTimers();
        menu.closest('nav').querySelectorAll('header-menu').forEach(other => {
          if (other !== menu) {
            other.querySelector('details').open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      };
      summary.addEventListener('click', event => {
        if (hover.matches && openedByPointer && details.open && event.detail > 0) { event.preventDefault(); openedByPointer = false; }
      });
      menu.addEventListener('pointerenter', event => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        cancelTimers();
        openTimer = setTimeout(() => { open(); openedByPointer = true; }, 120);
      });
      menu.addEventListener('pointerleave', event => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        cancelTimers();
        closeTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 240);
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          summary.focus();
        } else if (event.key === 'ArrowDown' && summary.contains(event.target)) {
          event.preventDefault();
          open();
          details.querySelector('summary + * a')?.focus();
        }
      });
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      hover.addEventListener('change', close);
    });
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const destination = new URL(anchor.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
    anchor.closest('header-drawer')?.closeMenuDrawer(event);
    const disclosure = anchor.closest('header-menu');
    if (disclosure) disclosure.querySelector('details').open = false;
  });
  setupArwHoverMenus();
  document.addEventListener('shopify:section:load', event => setupArwHoverMenus(event.target));

  } catch(e) { console.error(e); }
})();
})();
